module.exports = __webpack_public_path__ + "static/media/privacy_search-find-privacy-friendly.8d34c1b9.webp";